export type LexiconRevisionsManifest = {
  azure: Record<string, string>;
  google: Record<string, string>;
};

const LOCALE_KEY_RE = /^[a-zA-Z]{2}-[a-zA-Z]{2,}$/;

function normalizeRevisionMap(map: unknown): Record<string, string> {
  if (!map || typeof map !== 'object' || Array.isArray(map)) {
    return {};
  }

  const out: Record<string, string> = {};
  for (const [locale, revision] of Object.entries(map)) {
    if (!LOCALE_KEY_RE.test(locale)) continue;
    if (revision == null || String(revision).trim() === '') continue;
    out[locale] = String(revision).trim();
  }
  return out;
}

/** Normalize S3 manifest JSON (v2 provider maps or legacy flat Azure map). */
export function normalizeLexiconManifest(
  raw: unknown
): LexiconRevisionsManifest {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return { azure: {}, google: {} };
  }

  const obj = raw as Record<string, unknown>;

  if ('azure' in obj || 'google' in obj) {
    return {
      azure: normalizeRevisionMap(obj.azure),
      google: normalizeRevisionMap(obj.google)
    };
  }

  return { azure: normalizeRevisionMap(obj), google: {} };
}

export function getManifestRevision(
  manifest: LexiconRevisionsManifest,
  provider: string,
  voiceLocale: string
): string | null {
  if (!voiceLocale) return null;

  const normalizedProvider = String(provider).toLowerCase();
  const section =
    normalizedProvider === 'google'
      ? manifest.google
      : normalizedProvider === 'azure'
        ? manifest.azure
        : null;

  if (!section) return null;

  const revision = section[voiceLocale];
  return revision?.trim() ? revision.trim() : null;
}
